import { render, staticRenderFns } from "./pghome.vue?vue&type=template&id=2dbbc9da&scoped=true&"
import script from "./pghome.vue?vue&type=script&lang=js&"
export * from "./pghome.vue?vue&type=script&lang=js&"
import style0 from "./pghome.vue?vue&type=style&index=0&id=2dbbc9da&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dbbc9da",
  null
  
)

export default component.exports